import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import PatientBasicInfo from './components/PatientBasicInfo';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle';
import PatientClinicHistory from './components/clinicHistory/PatientClinicHistory';
import history from '../../../history';
import classnames from 'classnames';
import InvoicesPatient from './components/invoicesFromPatient/InvoicesPatient';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookMedical, faUserCircle, faFileInvoiceDollar, faReceipt, faCalendarCheck, faFileInvoice, faHeadSideVirus, faPrescriptionBottleAlt, faDisease, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import PatientsReceipts from './components/receiptsFromPatients/PatientsReceipts';
import PatientsAppointments from './components/appointmentsFromPatient/PatientsAppointments';
import ProfileAccountStatus from '../../Billfold/components/AccountStatus/ProfileAccountStatus';
import PatientsPayments from './components/paymentsPatient/PatientsPayments';
import useWindowDimensions from '../../../utils/costumeHooks/useWindowDimensions';
import PatientDiagnosis from './components/patientDiagnosis/PatientDiagnosis';
import {
    validateProcessECO, validateProcessEstres, validateProcessPrueba, validateProcessEKG,
    validateProcessHolter, validateProcessMapa
} from '../../Utils/UtilOtherProcedures';
import OrdensAndMedicinesPatient from './components/ordensMedicines/OrdensAndMedicinesPatient';
import PatientsDocuments from './components/documentsFromPatient/PatientsDocuments';
import PatientAlergies from './components/alergies/PatientAlergies';

const ShowPatientInformation = (props) => {
    const [activeTab, setActiveTab] = useState('1');
    const [patient, setPatient] = useState(null);
    const [clinicHistoryByPatient, setClinicHistoryByPatient] = useState(null);
    const { width, height } = useWindowDimensions();

    const goBackPatientsList = () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/patient-list',
        });
    }

    const onToggleTabs = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    useEffect(() => {
        const loadClinicHistory = async (id_historia) => {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/historia_clinica/' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("HIST", data);
                    //setClinicHistoryByPatient(data);
                    filterClinicHistoriesFromEmpty(data.admisiones);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        if (patient !== null && patient !== undefined) {
            loadClinicHistory(patient?.id_historia);
        }
    }, [patient])

    const filterClinicHistoriesFromEmpty = async (wholeClinicHistories) => {
        let clinicHistoryToShow = [];
        for (let i = 0; i < wholeClinicHistories.length; i++) {
            console.log(wholeClinicHistories[i]);
            if (wholeClinicHistories[i].hasOwnProperty("anamnesis")) {
                if (wholeClinicHistories[i].hasOwnProperty("procedimientos")) {
                    let resultsPocedures = [];
                    if (wholeClinicHistories[i].procedimientos.eco.hasOwnProperty('eco') ||
                        wholeClinicHistories[i].procedimientos.estres.hasOwnProperty('estres') ||
                        wholeClinicHistories[i].procedimientos.prueba.hasOwnProperty('prueba') ||
                        wholeClinicHistories[i].procedimientos.ekg.hasOwnProperty('ekg') ||
                        wholeClinicHistories[i].procedimientos.holter.hasOwnProperty('holter') ||
                        wholeClinicHistories[i].procedimientos.mapa.hasOwnProperty('mapa')) {

                        let resultOtherProcedureEco = await validateProcessECO(wholeClinicHistories[i].procedimientos.eco.eco[0]) ? wholeClinicHistories[i].procedimientos.eco.eco[0].conclusiones : null;
                        let resultOtherProcedureEstres = await validateProcessEstres(wholeClinicHistories[i].procedimientos.estres.estres[0]) ? wholeClinicHistories[i].procedimientos.estres.estres[0].conclusiones : null;
                        let resultOtherProcedurePrueba = await validateProcessPrueba(wholeClinicHistories[i].procedimientos.prueba.prueba[0]) ? wholeClinicHistories[i].procedimientos.prueba.prueba[0].conclusiones : null;
                        let resultOtherProcedureEkg = await validateProcessEKG(wholeClinicHistories[i].procedimientos.ekg.ekg[0]) ?
                            wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== undefined &&
                                wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions :
                                wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== undefined &&
                                    wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion : null : null;
                        let resultOtherProcedureHolter = await validateProcessHolter(wholeClinicHistories[i].procedimientos.holter.holter[0]) ? wholeClinicHistories[i].procedimientos.holter.holter[0].conclusion : null;
                        let resultOtherProcedureMapa = await validateProcessMapa(wholeClinicHistories[i].procedimientos.mapa.mapa[0]) ? wholeClinicHistories[i].procedimientos.mapa.mapa[0].conclusion : null;

                        if (resultOtherProcedureEco !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '1');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEco });
                            }
                        }
                        if (resultOtherProcedureEstres !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '3');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEstres });
                            }
                        }
                        if (resultOtherProcedurePrueba !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '4');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedurePrueba });
                            }
                        }
                        if (resultOtherProcedureEkg !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '2');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEkg });
                            }
                        }
                        if (resultOtherProcedureHolter !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '6');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureHolter });
                            }
                        }
                        if (resultOtherProcedureMapa !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '7');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureMapa });
                            }
                        }
                    }
                    clinicHistoryToShow.push(wholeClinicHistories[i]);
                }
                //clinicHistoryToShow.push(wholeClinicHistories[i]);
            } else if (wholeClinicHistories[i].hasOwnProperty("procedimientos")) {
                let resultsPocedures = [];
                if (wholeClinicHistories[i].procedimientos.eco.hasOwnProperty('eco') ||
                    wholeClinicHistories[i].procedimientos.estres.hasOwnProperty('estres') ||
                    wholeClinicHistories[i].procedimientos.prueba.hasOwnProperty('prueba') ||
                    wholeClinicHistories[i].procedimientos.ekg.hasOwnProperty('ekg') ||
                    wholeClinicHistories[i].procedimientos.holter.hasOwnProperty('holter') ||
                    wholeClinicHistories[i].procedimientos.mapa.hasOwnProperty('mapa')) {

                    let resultOtherProcedureEco = await validateProcessECO(wholeClinicHistories[i].procedimientos.eco.eco[0]) ? wholeClinicHistories[i].procedimientos.eco.eco[0].conclusiones : null;
                    let resultOtherProcedureEstres = await validateProcessEstres(wholeClinicHistories[i].procedimientos.estres.estres[0]) ? wholeClinicHistories[i].procedimientos.estres.estres[0].conclusiones : null;
                    let resultOtherProcedurePrueba = await validateProcessPrueba(wholeClinicHistories[i].procedimientos.prueba.prueba[0]) ? wholeClinicHistories[i].procedimientos.prueba.prueba[0].conclusiones : null;
                    let resultOtherProcedureEkg = await validateProcessEKG(wholeClinicHistories[i].procedimientos.ekg.ekg[0]) ?
                        wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== undefined &&
                            wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions :
                            wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== undefined &&
                                wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion : null : null;
                    let resultOtherProcedureHolter = await validateProcessHolter(wholeClinicHistories[i].procedimientos.holter.holter[0]) ? wholeClinicHistories[i].procedimientos.holter.holter[0].conclusion : null;
                    let resultOtherProcedureMapa = await validateProcessMapa(wholeClinicHistories[i].procedimientos.mapa.mapa[0]) ? wholeClinicHistories[i].procedimientos.mapa.mapa[0].conclusion : null;

                    if (resultOtherProcedureEco !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '1');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEco });
                        }
                    }
                    if (resultOtherProcedureEstres !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '3');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEstres });
                        }
                    }
                    if (resultOtherProcedurePrueba !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '4');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedurePrueba });
                        }
                    }
                    if (resultOtherProcedureEkg !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '2');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEkg });
                        }
                    }
                    if (resultOtherProcedureHolter !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '6');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureHolter });
                        }
                    }
                    if (resultOtherProcedureMapa !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '7');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureMapa });
                        }
                    }
                    clinicHistoryToShow.push(wholeClinicHistories[i]);
                }

            } else if (wholeClinicHistories[i].transcripcion !== null && wholeClinicHistories[i].transcripcion !== undefined) {
                clinicHistoryToShow.push(wholeClinicHistories[i]);
            }
        }
        console.log("WHOLE", clinicHistoryToShow);
        setClinicHistoryByPatient(clinicHistoryToShow);
    }


    return (
        <Fragment>
            <Container>
                <Row>
                    <Col md={3}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', margin: '0em 2em' }}>
                            <div>
                                <Tooltip
                                    title="Regresar a Base de Datos de Pacientes"
                                    style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            //this.warningToGoBackToClinicsHistoryList();
                                            goBackPatientsList();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <div>
                                <h3 style={{ marginBottom: 5, padding: '0em 0.5em' }}>Perfil</h3>
                            </div>
                        </div>
                    </Col>
                    <Col md={9}>
                        <div className='top-info-patient'>
                            <div>
                                <FontAwesomeIcon className='avatar-icon-top' style={{ width: '2em', height: '2em' }} icon={faUserCircle} />
                            </div>
                            <div>
                                {patient &&
                                    <h4>{patient.tip_documento + ' ' + patient.num_documento} - <b>{patient.nombres + ' ' + patient.apellido1 + ' ' + patient.apellido2}</b></h4>
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} xs={12}>
                        <div className={width <= 768 ? "tabs tabs--bordered-top" : "tabs tabs--vertical"}>
                            <div className="tabs__wrap">
                                <Col md={3} className="tab-spacing-profile">
                                    <Nav tabs vertical style={{ width: '100%' }}>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => {
                                                    onToggleTabs('1');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faUserCircle} />
                                                Perfil
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => {
                                                    onToggleTabs('2');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faBookMedical} />
                                                Historia Clínica
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '3' })}
                                                onClick={() => {
                                                    onToggleTabs('3');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faHeadSideVirus} />
                                                Diagnósticos
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '4' })}
                                                onClick={() => {
                                                    onToggleTabs('4');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faPrescriptionBottleAlt} />
                                                Ordenes y Formulas
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '5' })}
                                                onClick={() => {
                                                    onToggleTabs('5');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faDisease} />
                                                Alergias
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '6' })}
                                                onClick={() => {
                                                    onToggleTabs('6');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faCalendarCheck} />
                                                Citas
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '7' })}
                                                onClick={() => {
                                                    onToggleTabs('7');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faFileInvoiceDollar} />
                                                Facturas
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '8' })}
                                                onClick={() => {
                                                    onToggleTabs('8');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faReceipt} />
                                                Recibos de Caja
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '9' })}
                                                onClick={() => {
                                                    onToggleTabs('9');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faFileInvoice} />
                                                Estado de Cuenta
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '10' })}
                                                onClick={() => {
                                                    onToggleTabs('10');
                                                }}
                                            >
                                                <SwapVerticalCircleIcon className='icon-patient-profile' style={{ margin: '0em 0.5em' }} />
                                                {/* <FontAwesomeIcon className='icon-patient-profile' icon={faFileInvoice} /> */}
                                                Pagos
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '11' })}
                                                onClick={() => {
                                                    onToggleTabs('11');
                                                }}
                                            >
                                                <FontAwesomeIcon className='icon-patient-profile' icon={faFolderOpen} />
                                                Documentos
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Col>
                                <Col md={9} xs={12}>
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <Row className='basic-patient-info'>
                                                <PatientBasicInfo id_patient={props.location.state.id_patient} setPatientTop={setPatient} />
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '2' ?
                                                        <PatientClinicHistory id_patient={props.location.state.id_patient} clinicHistoryByPatient={clinicHistoryByPatient} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '3' ?
                                                        patient &&
                                                        <PatientDiagnosis id_historia={patient.id_historia} clinicHistoryByPatient={clinicHistoryByPatient} patient={patient} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '4' ?
                                                        patient &&
                                                        <OrdensAndMedicinesPatient id_historia={patient.id_historia} clinicHistoryByPatient={clinicHistoryByPatient} patient={patient} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '5' ?
                                                        patient &&
                                                        <PatientAlergies id_historia={patient.id_historia} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="6">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '6' ?
                                                        <PatientsAppointments id_patient={props.location.state.id_patient} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="7">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '7' ?
                                                        <InvoicesPatient id_patient={props.location.state.id_patient} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="8">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '8' ?
                                                        <PatientsReceipts id_patient={props.location.state.id_patient} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="9">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '9' ?
                                                        patient &&
                                                        <ProfileAccountStatus id_historia={patient?.id_historia} id_tercero={null} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="10">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '10' ?
                                                        patient &&
                                                        <PatientsPayments id_historia={patient?.id_historia} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="11">
                                            <Row className='basic-patient-info'>
                                                {
                                                    activeTab === '11' ?
                                                        patient &&
                                                        <PatientsDocuments id_historia={patient?.id_historia} />
                                                        : null
                                                }
                                            </Row>
                                        </TabPane>
                                    </TabContent>
                                </Col>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default ShowPatientInformation